export default __webpack_public_path__ + "static/media/spotify_rounded.4d3bd344.svg";